export enum SubRoleEnum {
  ADVERTISER_MANAGER = "SUB_ROLE_ADVERTISER_MANAGER",
  LOCATION_MANAGER = "SUB_ROLE_LOCATION_MANAGER",
  ADMIN_MANAGER = "SUB_ROLE_ADMIN_MANAGER",
  FRANCHISE_MANAGER = "SUB_ROLE_FRANCHISE_MANAGER",
  FRANCHISED = "SUB_ROLE_FRANCHISED"
}

export const SubRoleEnumMapping: Record<SubRoleEnum, string> = {
  [SubRoleEnum.ADVERTISER_MANAGER]: "Advertiser Manager",
  [SubRoleEnum.LOCATION_MANAGER]: "location Manager",
  [SubRoleEnum.ADMIN_MANAGER]: "Admin Manager",
  [SubRoleEnum.FRANCHISE_MANAGER]: "Franchise Manager",
  [SubRoleEnum.FRANCHISED]: "Franchised",
};

export interface SubRoleNamesInterface {
  id: SubRoleEnum;
  value: string;
}
